import React from "react";
import {
  SessaoApresentacao,
  SessaoApoiadores,
  SessaoPaineis,
  SessaoNoticias,
} from "../../components/page_components/HomePage";

function Home() {
  return (
    <>
      <SessaoApresentacao />
      <SessaoPaineis />
      <SessaoNoticias />
      <SessaoApoiadores />
    </>
  );
}

export default Home;
